import { ApiGatewayKey } from '@types';
import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetApiGatewayKeysResponse = {
	apiGatewayKey: Array<ApiGatewayKey>;
};

export const getApiGatewayKeys = createGetEndpoint<void, GetApiGatewayKeysResponse>(
	'/api/v3/security/api-gateway-keys'
);
